import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

import { NgxGroupService } from './group.service';

export const ngxGroupServiceModule = angular.module('ngxGroupServiceModule', [])
	.factory('ngxGroupService', downgradeInjectable(NgxGroupService) as any)
	.name;
